import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS, FAQ_INTRO } from "@/data/content";
import { useT } from "@/i18n/LanguageContext";

export const FAQSection = () => {
  const t = useT();

  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 lg:py-32">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="uppercase text-xs tracking-[0.25em] text-[#1A1A1F] font-bold">
            {t(FAQ_INTRO.eyebrow)}
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight mt-4">
            {t(FAQ_INTRO.title)}
          </h2>
        </motion.div>

        <Accordion type="single" collapsible data-testid="faq-accordion" className="mt-12">
          {FAQS.map((faq, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.08 }}
            >
              <AccordionItem
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-[#E8E7E2]"
              >
                <AccordionTrigger className="font-heading text-left text-base sm:text-lg hover:text-[#1A1A1F] hover:no-underline transition-colors duration-300">
                  {t(faq.q)}
                </AccordionTrigger>
                <AccordionContent className="text-[#62646B] leading-relaxed">
                  {t(faq.a)}
                </AccordionContent>
              </AccordionItem>
            </motion.div>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
